import React from 'react';
import styled from 'styled-components';
import { Button } from './../../styles/Button';
import FormatPrice from './../../Helpers/FormatPrice';
import CartItem from '../CartItem';

const CartSummary = ({
  cart = [],
  total_price,
  shippingCharges,
  onOrderNow
}) => {
  const total_quantity = cart.reduce(
    (acc, curElem) => acc + curElem.quantity, 0);
  const orderTotal = total_price + shippingCharges;
  return (
    <Wrapper>
      <div className="cart-section">
        <h3> Cart Summary </h3>
        <div className="cart-list">

          <table className="cart-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Subtotal</th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              {cart.map((curElem) => (
                <CartItem key={curElem.SKU} {...curElem} />
              ))
              }
              <tr>
                <td style={{ textAlign: "left", fontWeight: "bold" }} >
                  Sub Total
                </td>
                <td></td>
                <td></td>
                <td>
                  <FormatPrice price={total_price} />
                </td>
                <td></td>
              </tr>
              <tr>
                <td style={{ textAlign: "left", fontWeight: "bold" }} >
                  Shipping Fee:
                </td>
                <td></td>
                <td></td>
                <td> <FormatPrice price={shippingCharges} />
                </td>
                <td></td>
              </tr> <tr>
                <td style={{ textAlign: "left", fontWeight: "bold" }} >
                  Total:
                </td> <td>
                </td>
                <td> {total_quantity} </td>
                <td>
                  <strong>
                    <FormatPrice price={orderTotal} />
                  </strong>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="order-button">
          <Button onClick={onOrderNow}
          style={{ backgroundColor: "#6F9F86", color: "#fff" }}>
            Order Now
          </Button>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section` 
  .cart-table { 
  width: 100%; 
  border-collapse: collapse; 
  margin: 1rem 0; 
  font-size: 1.5rem; 
  } 
  
  .cart-table th, 
  .cart-table td { 
  border: 1px solid #ddd; 
  padding: 0.75rem; 
  text-align: center; 
  } 
  
  .cart-table th {   
  background-color: #f4f4f4; 
  font-weight: 600; 
  } 
  
   /* ADD THIS */
  .cart-item-info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .cart-item-img {
    width: 60px;
    height: 60px;
    object-fit: contain;
    border-radius: 4px;
  }

  /* ADD THIS TOO */
  .cart-item-info p {
    margin: 0;
  }
  
  
  @media (max-width: ${({ theme }) => theme.media.mobile}) {
   .cart-section { 
   margin-top: 1rem; 
   padding: 0.5rem; 
   } 
   
   .cart-table, 
   .cart-table thead, 
   .cart-table tbody, 
   .cart-table th, 
   .cart-table td, 
   .cart-table tr { 
   display: block; 
   width: 100%; 
   } 
  
  .cart-table thead { 
   display: none; 
   } 
   
  .cart-table tr { 
    margin-bottom: 1rem; 
    border: 1px solid #ddd; 
    border-radius: 6px;
    padding: 0.75rem; 
    background: #fff; } 
    
    .cart-table td { 
    display: flex; 
    justify-content: space-between; 
    align-items: center; 
    padding: 0.5rem; 
    border: none; 
    border-bottom: 1px solid #eee; 
    } 
    
    
  .cart-table td:last-child { 
    border-bottom: none; }

    .cart-table td::before { 
    content: attr(data-label); 
    font-weight: 500; 
    text-transform: capitalize; 
    flex: 1; 
    text-align: left; 
    color: #555; 
    } 

  .cart-item-img {
      width: 60px;
      height: 60px;
    }

.order-button Button
{
    width:10rem;
  
    }

    } `;

export default CartSummary;